import { importClassOnScroll } from "../../utilities/dynamicImportsUtility";

export default class TpiElement extends HTMLElement {
  public constructor() {
    super();
  }

  public connectedCallback() {
    console.debug("TPI element controller registered");
    if (document.readyState === "loading") {
      window.addEventListener("DOMContentLoaded", () => this.initialize());
    } else {
      this.initialize();
    }
  }

  private initialize() {
    importClassOnScroll(
      () =>
        import(
          /* webpackChunkName: "tpiElementController" */ "./tpiElementController"
        ),
      this,
      true,
      null,
      this
    );
  }
}

customElements.define("tpi-element", TpiElement);
